import React, { useState } from "react";
import { Layout } from "antd";
import Sider from "./../commonFrames/Sider";
import SubPageConatainer from "./SubPageConatainer";
import Styles from "./Styles";

const { Content } = Layout;

export const SinglePageLayout = ({ pageInfo }) => {
  return <Styles className='single-page-layout'>{pageInfo}</Styles>;
};

const SubPageLayout = ({ pageInfo }) => {
  // 모바일 Sider 기본값 접힌 상태
  const [isSiderOpen, setSiderOpen] = useState(false);
  return (
    <Styles className='sub-page-layout'>
      <Layout>
        <Sider isSiderOpen={isSiderOpen} setSiderOpen={setSiderOpen} />
        <Content>
          <SubPageConatainer isSiderOpen={isSiderOpen} setSiderOpen={setSiderOpen} page={pageInfo} />
        </Content>
      </Layout>
    </Styles>
  );
};

export default SubPageLayout;
